import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ms-my-bets-scoreboard-soccer-red-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="mybets-scoreboard_stats-red-card-indicator">
            @for (card of cards; track card) {
                <span class="mybets-scoreboard_stats-red-card"></span>
            }
        </div>
    `,
})
export class MyBetsScoreboardSoccerRedCardComponent {
    cardsCount = input<number>(0);

    get cards(): number[] {
        return this.cardsCount() >= 0 ? Array.apply(0, Array(this.cardsCount())).map((x: any, i: number) => i) : [];
    }
}
